import {
  CUSTOM_AMOUNT_OPTION,
  CUSTOM_SESSION_DURATION
} from '../../../../constants';
import { ActivityDepositLimit, LimitConfig, Options } from '../../types';

interface IProps {
  isEdit: boolean;
  depositLimit: Partial<LimitConfig>;
  durationLimit: Partial<LimitConfig>;
  gameActivityLimit: ActivityDepositLimit;
  maxDepositLimit: ActivityDepositLimit;
  options: Options;
  isSavedLimitsPeriodChanged: boolean;
}

export const getDynamicValues = ({
  isEdit,
  depositLimit,
  durationLimit,
  gameActivityLimit,
  maxDepositLimit,
  options,
  isSavedLimitsPeriodChanged
}: IProps) => {
  if (
    !gameActivityLimit ||
    !maxDepositLimit ||
    (isSavedLimitsPeriodChanged && !isEdit)
  ) {
    return {
      limit: depositLimit.defaultValue,
      duration: durationLimit.defaultValue,
      amount: undefined,
      durationAmount: undefined
    };
  }
  const IS_CUSTOM_LIMIT = options?.limit?.every(
    ({ value }) => value !== maxDepositLimit.amount
  );
  const IS_CUSTOM_DURATION = options?.duration?.every(
    ({ value }) => value !== gameActivityLimit.amount
  );
  return {
    period: gameActivityLimit?.period,
    limit: IS_CUSTOM_LIMIT ? CUSTOM_AMOUNT_OPTION : maxDepositLimit.amount,
    amount: IS_CUSTOM_LIMIT ? maxDepositLimit.amount : undefined,
    duration: IS_CUSTOM_DURATION
      ? CUSTOM_SESSION_DURATION
      : gameActivityLimit.amount,
    durationAmount: IS_CUSTOM_DURATION
      ? +gameActivityLimit.amount / 3600
      : undefined
  };
};
